import { useEffect, useMemo } from "react";

import {
    type ProductAction,
    type ProductEntry,
    type ProductFlow,
    ProductJourney,
    type ProductProperties
} from "./productEvents";

export function useProductJourney(
    flow: ProductFlow,
    entry: ProductEntry,
    address?: string,
    active = true
): ProductJourney {
    // A new visible visit or account starts a new journey. Strict Mode rerenders do not emit events.
    return useMemo(() => {
        // `active` is not passed to the journey; it is read only to key the journey to the visit.
        void active;
        return new ProductJourney(flow, entry, address);
    }, [flow, entry, address, active]);
}

export function useProductObservation(
    journey: ProductJourney,
    action: ProductAction,
    properties: ProductProperties = {},
    active = true
): void {
    const key = JSON.stringify(properties);
    useEffect(() => {
        if (active) journey.changed(action, JSON.parse(key) as ProductProperties);
    }, [journey, action, key, active]);
}
